export default [
  {
    value: 'performance.dom_content_loaded.average',
    label: 'performance.dom_content_loaded.average',
    unit: 'ms',
  },
  {
    value: 'performance.first_meaningful_paint.average',
    label: 'performance.first_meaningful_paint.average',
    unit: 'ms',
  },
  {
    value: 'performance.page_load_time.average',
    label: 'performance.page_load_time.average',
    unit: 'ms',
  },
  {
    value: 'performance.dom_build_time.average',
    label: 'performance.dom_build_time.average',
    unit: 'ms',
  },
  {
    value: 'performance.speed_index.average',
    label: 'performance.speed_index.average',
    unit: 'ms',
  },
  {
    value: 'performance.page_response_time.average',
    label: 'performance.page_response_time.average',
    unit: 'ms',
  },
  {
    value: 'performance.ttfb.average',
    label: 'performance.ttfb.average',
    unit: 'ms',
  },
  {
    value: 'performance.time_to_render.average',
    label: 'performance.time_to_render.average',
    unit: 'ms',
  },
  {
    value: 'performance.crashes.count',
    label: 'performance.crashes.count',
    unit: '',
  },
  {
    value: 'errors.javascript.count',
    label: 'errors.javascript.count',
    unit: '',
  },
  { value: 'errors.backend.count', label: 'errors.backend.count', unit: '' },
] as const;
